import React, { useState } from "react";
import { Col, Form } from "react-bootstrap";
import LockIcon from "assets/icons/lock-icon.png";

import { useForm } from "react-hook-form";

import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import { Link } from "react-router-dom";

import CreatePasswordFields from "./CreatePasswordFields";
import axios from "../../axiosConfig";

function ChangePassword({
  paramsUID,
  paramsToken,

  setView,
  nextView,

  // setShow,
  // setShowLogin,
  ...props
}) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Watch password input changes
  // Validation schema
  const schema = yup.object().shape({
    password: yup
      .string()
      .min(8)
      .required()
      .matches(/[A-Z]/)
      .matches(/[a-z]/)
      .matches(/\d/),
    confirmPassword: yup
      .string()
      .oneOf([yup.ref("password"), null], "Passwords do not match")
      .required("Please confirm the password"),
  });
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm({
    defaultValues: {
      password: "",
      confirmPassword: "",
    },
    mode: "onChange",
    // Define validation schema
    resolver: yupResolver(schema),
  });

  const onSubmit = formValues => {
    setLoading(true);
    axios
      .put(`/api/auth/change-password/${paramsUID}/${paramsToken}`, {
        password: formValues.password,
      })
      .then(response => {
        setView(nextView);
      })
      .catch(error => {
        setError(
          error.response.data.message.non_field_errors ||
            "We couldn't complete your request."
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    <>
      {/* Header section */}
      <Col sm={12} className="modal-header px-2">
        <img src={LockIcon} alt="lock-icon" />
        <h3 className="mt-4 mb-3">Reset your password</h3>
        <p className="mb-0 lh-base">
          Please create a new password and confirm it. After that you will be
          able to login again
        </p>
      </Col>
      {/* Form section */}

      {/* First step */}
      <Form sm={12} noValidate onSubmit={handleSubmit(onSubmit)}>
        <CreatePasswordFields
          register={register}
          errors={errors}
          watch={watch}
        />
        <div className="form-group pt-2 pb-2">
          <button
            className="btn btn-primary btn-block btn-full"
            disabled={loading}
            // onClick={handleRequestChangingPassword}
          >
            {loading && (
              <span className="spinner-border spinner-border-sm"></span>
            )}
            {loading ? "Loading" : "Reset Password"}
          </button>
        </div>
        {error && (
          <div className="form-group mt-3">
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          </div>
        )}
      </Form>
    </>
  );
}

export default ChangePassword;
